import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useUser } from '../context/UserContext';


const Home = () => {
	const { user } = useUser()

	useEffect(() => {
		if (user) {
			toast('Welcome back.', {
				position: 'bottom-left'
			})
		}
	}, [user])

	return (
		<>
			<div id="home" className="home">
				<div className="row">
					<Link className="home__main-link home__main-link--inverted col-lg-3 col-md-6 col-12 cta--large" to="/prepare-weekly-roundup">Prepare Weekly Roundup</Link>
					<Link className="home__main-link col-lg-3 col-md-6 col-12 cta--large" to="/manage-goals">Manage Your Goals</Link>
					<Link className="home__main-link col-lg-3 col-md-6 col-12 cta--large" to="/manage-year">Manage Your Year</Link>
					<Link className="home__main-link col-lg-3 col-md-6 col-12 cta--large" to="/manage-models">Manage Your Models</Link>
				</div>
				<div className="row home__ad-wrapper">
					<div className="ad-banner ad-banner--landscape">
						Possible advertising space
					</div>
				</div>
			</div>
			<ToastContainer />
		</>
	);
};

export default Home